import { render, staticRenderFns } from "./position.vue?vue&type=template&id=4ae4d06a&scoped=true&"
import script from "./position.vue?vue&type=script&lang=js&"
export * from "./position.vue?vue&type=script&lang=js&"
import style0 from "./position.vue?vue&type=style&index=0&id=4ae4d06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae4d06a",
  null
  
)

component.options.__file = "position.vue"
export default component.exports